export const documentStateTypes = [
    { val: "1", label: "În desfășurare" },
    { val: "2", label: "Atribuită" },
    { val: "3", label: "Anulată" },
]
